import { Col, Row } from "reactstrap";
import { RecentPosts, TrendingPosts } from "../../../../Constants/Constants";
import { RecentPostsData, TrendingPostsData } from "../../../../Data/Blog/Blog";
import { dynamicImage, Image } from "../../../../Utils";
import Search from "./Search";

const Sidebar = () => {
  return (
    <Row>
      <Col xl="12" lg="4" sm="6">
        <h4>{TrendingPosts}</h4>
        <ul className="recent-blog trending-blog">
          <li>
            {TrendingPostsData.map((item, index) => (
              <div className="d-flex gap-2 align-items-start" key={index}>
                <h4>0{index + 1}.</h4>
                <div className="flex-grow-1">
                  <h6>{item.title}</h6>
                  <p>{item.date}</p>
                </div>
              </div>
            ))}
          </li>
        </ul>
      </Col>
      <Search />
      <Col xl="12" lg="4" sm="12">
        <h4>{RecentPosts}</h4>
        <ul className="recent-blog">
          {RecentPostsData.map((item, index) => (
            <li key={index}>
              <div className="d-flex gap-2 align-items-start">
                <Image className="img-fluid rounded" src={dynamicImage(`blog/small/${index + 1}.jpg`)} alt="Generic placeholder image" />
                <div className="flex-grow-1">
                  <h6>{item}</h6>
                  <p>{"3 months ago"}</p>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Col>
    </Row>
  );
};

export default Sidebar;
